import { useRouter } from "next/router"
import { navigatorRoutesPaths } from "@/routes/navigator"
import { onboardingRoutesPaths } from "@/routes/onboarding"
import { useMeterPowerAnalysisWizard } from "../wizard"

export function useOnboardingRedirection() {
    const router = useRouter()
    const { formValues } = useMeterPowerAnalysisWizard()

    function redirectToOnboardingJourney() {
        const { pmaxToken, affiliateCode, rewardCode, meterPointId, user } = formValues

        const queryParams = {
            ...(affiliateCode ? { affiliate: affiliateCode } : {}),
            ...(rewardCode ? { codeParrainage: rewardCode } : {}),
            ...(pmaxToken ? { pmaxToken } : {}),
            ...(!pmaxToken && meterPointId ? { electricityMeterPointId: meterPointId } : {}),
            ...(!pmaxToken && user.firstName ? { givenName: user.firstName } : {}),
            ...(!pmaxToken && user.lastName ? { familyName: user.lastName } : {}),
        }

        const searchParams = new URLSearchParams(queryParams)
        const queryString = searchParams.toString()

        const redirectionPath = affiliateCode
            ? navigatorRoutesPaths.meterDetails.resolve()
            : onboardingRoutesPaths.meterDetails.resolve()

        // Only append the searchParams if it has keys
        const url = queryString.length > 0 ? `${redirectionPath}?${queryString}` : redirectionPath

        return router.push(url)
    }

    return redirectToOnboardingJourney
}
